module.exports = __webpack_public_path__ + "static/media/Onestone.5b567a6c.png";